// URL: https://www.dwtc.com/en/plan-visit

import React, { useState } from 'react';
import Slider from 'react-slick';
import { Container } from './styles/Container.styled';
import { VisitFeature } from './styles/VisitFeature.styled';

import {
  ButtonTab,
  TabDescription,
  DescriptionSection,
  Spanpt,
  ContentBox,
  TabWrapper,
  TripButtonDiv,
} from './styles/FacilitiesTabSection.styled';
import { Row } from './styles/Row.styled';
import { LoadMoreButton } from './styles/LoadMoreButton.styled';
import Sprites from './Sprites';
import { NextArrow, PrevArrow } from './NextPrevArrow';

export default function TripPlanner({ data, id, dir }) {
  const [toggleState, setToggleState] = useState(0);
  const handleNext = (curr, last) => setToggleState(+curr + 1 < +last ? +curr + 1 : +last);
  const handlePrev = (curr) => setToggleState(+curr - 1 > 0 ? +curr - 1 : 0);
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          autoplay: false,
          arrows: true,
          centerMode: true,
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          autoplay: false,
          arrows: true,
          centerMode: true,
          centerPadding: '70px',
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          autoplay: false,
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          autoplay: false,
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
    ],
  };
  const { trips } = data;

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <VisitFeature id={id} className="tabgroup_section trip_planner">
      <Container>
        <TabWrapper dir={dir} className="trip_planner_tab">
          <Slider {...settings} dir={dir}>
            {trips.map(({ content }, index) => (
              <ButtonTab
                className={toggleState === index ? 'tabs active-tabs' : 'tabs'}
                onClick={() => toggleTab(index)}
                dir={dir}
              >
                <Sprites name={content.iconName} />
                <Spanpt dir={dir}>{content.title}</Spanpt>
              </ButtonTab>
            ))}
          </Slider>
        </TabWrapper>
      </Container>

      <TabDescription id={id} className="tabgroup_descp padnbtn_tabdesc">
        <Container>
          {trips.map((trip, index) => (
            <DescriptionSection
              className={toggleState === index ? 'content  active-content' : 'content'}
            >
              <Row className="no-gutters">
                {trip.content.items.map(({ content: { title, text, link } }) => (
                  <ContentBox className="tripplanner_box" dir={dir}>
                    <h3 dir={dir}>{title}</h3>
                    <p>{text}</p>
                    <TripButtonDiv dir={dir}>
                      <LoadMoreButton dir={dir}>
                        {link && (
                          <a href={link.url} target={link.target} rel="noreferrer" dir={dir}>
                            {link.name}
                          </a>
                        )}
                      </LoadMoreButton>
                    </TripButtonDiv>
                  </ContentBox>
                ))}
              </Row>
            </DescriptionSection>
          ))}
        </Container>
      </TabDescription>
    </VisitFeature>
  );
}
